import React, { FC, useEffect, useState, useRef } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import searchIcon from '../../images/Search.svg';

type Props = {
    setSearchTerm: (searchTerm: string) => void,
    className?: string
    searchTerm?: any
    disabled?: boolean
    cyName?: string
}

const SearchField: FC<Props> = ({ setSearchTerm, className, searchTerm, disabled = false, cyName }) => {
    const { translate } = useLocale();
    /**
        Use local state to store user input which will then update the search term.
        This is because updating search term with user input delay the search field on change since change in search term makes an api call.
     */

    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);

    // Logic that adds a delay before setting the search term which makes an api call.
    // This is an attempt to reduce the number of api calls made by the SearchField.
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        // clear any existing timeout to reset the debounce timer
        if (debounceTimeout.current) {
            clearTimeout((debounceTimeout.current));
        }

        // timeout delay of 700ms before setting the search term
        debounceTimeout.current = setTimeout(() => {
            if(localSearchTerm !== undefined) {
                setSearchTerm(localSearchTerm)
            }
        }, 700);

        // cleanup timeout
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current)
            }
        }
    }, [localSearchTerm]);

    return <div className={`flex flex-row justify-between items-center border text-gray-700 rounded ${className}`}>
        <input
            data-cy={`${cyName}SearchField`}
            className={`no-select p-1 no-select w-full text-xs ${disabled ? 'cursor-not-allowed' : ''}`} id="search"
            type="text"
            value={localSearchTerm}
            onChange={e => {
                setLocalSearchTerm(e.target.value)
            }}
            disabled={disabled}
            placeholder={translate.byKey(TranslationKeys.searchFieldPlaceholder)} />
        <img className={`mr-2 h-4`} src={searchIcon} alt="" />
    </div>;
};

export default SearchField;
